import { FtlRouteViewModel } from "../ViewModel/FtlRouteViewModel";
import { FtlRoutingViewModel } from "../ViewModel/FtlRoutingViewModel";
import { DraggableElement } from "../ViewModel/DraggableElement";
import { createUUID } from "../../Utils/CreateUUID";
import { getFormattedETValues } from "./RightSide/FtlTab/FtlRouteHeader/AddGsdb/getFormattedETValues";
import { dateToStringFormat } from "./RightSide/FtlTab/FtlRouteHeader/AddGsdb/dateToStringFormat";
import { createRoutingInfoForPlantDockRouting } from "./CreateRoutingInfo";
import { PuDo } from "../ViewModel/PuDo";
import { RoutingType } from "../ViewModel/RoutingType";

const generateRoutingJson = (
  route: FtlRouteViewModel,
  newElements: Array<DraggableElement>
): Array<FtlRoutingViewModel> => {
  if (!route || !newElements) {
    return [];
  }

  const routingJson: Array<FtlRoutingViewModel> = [];
  const crossingRoutingCountry: Array<any> = [];

  [...newElements].forEach((element: DraggableElement) => {
    if (!element.ClientId) {
      element.ClientId = createUUID();
    }

    const index = crossingRoutingCountry.findIndex((x) => x === element.RoutingInfo?.Country);
    if (index === -1) {
      crossingRoutingCountry.push(element.RoutingInfo?.Country);
    }

    if (element.RoutingInfo) {
      element.RoutingInfo = getFormattedETValues(element.RoutingInfo);
    }

    if (element.RoutingType === RoutingType.Supplier) {
      if (!element.RoutingInfo) {
        return;
      }
      const info: FtlRoutingViewModel = { ...element.RoutingInfo };
      if (!info.GeoLocation) {
        return;
      }
      if (
        info.GeoLocation.AltLocation != null &&
        info.GeoLocation.AltLocation.City != null &&
        info.GeoLocation.AltLocation.Zip != null &&
        info.GeoLocation.AltLocation.Country != null &&
        ((info.AltLocationForReturnOnly && info.PuDoType === PuDo.DO_R) ||
          !info.AltLocationForReturnOnly)
      ) {
        info.City = info.GeoLocation.AltLocation.City;
        info.Postcode = info.GeoLocation.AltLocation.Zip;
        info.Country = info.GeoLocation.AltLocation.Country.Name;
      }
      routingJson.push(info);
    } else if (element.RoutingType === RoutingType.Plant) {
      element.DockList?.forEach((dock) => {
        if (!dock.ClientId) {
          dock.ClientId = createUUID();
        }
        if (dock.ETA !== null && dock.ETA !== undefined) {
          dock.ETA = dateToStringFormat(dock.ETA, "HH:mm");
        } else {
          dock.ETA = "N/A";
        }
        if (dock.ETD !== null && dock.ETD !== undefined) {
          dock.ETD = dateToStringFormat(dock.ETD, "HH:mm");
        } else {
          dock.ETD = "N/A";
        }
        if (!element.RoutingInfo) {
          return;
        }
        routingJson.push(createRoutingInfoForPlantDockRouting(element, dock));
      });
    } else if (element.RoutingType === RoutingType.EDC) {
      if (!element.RoutingInfo.ClientId) {
        element.RoutingInfo.ClientId = createUUID();
      }
      routingJson.push({ ...element.RoutingInfo, RoutingType: RoutingType.Dock });
    } else if (element.RoutingInfo) {
      if (!element.RoutingInfo.ClientId) {
        element.RoutingInfo.ClientId = createUUID();
      }
      routingJson.push(element.RoutingInfo);
    }
  });

  crossingRoutingCountry.forEach((countryString) => {
    const index = route.CrossingCountries?.findIndex((x) => x.Name === countryString);
    if (!(index === -1 && countryString !== undefined)) {
      return;
    }

    route.CrossingCountries?.push({
      CrossingCountryId: createUUID(),
      Name: countryString,
      InboundMautKM: 0,
      ReturnMautKM: 0,
    });
  });

  return routingJson;
};

export default generateRoutingJson;
